const getArticulosByBandera = async () => {
  try {
    const puesto = JSON.parse(localStorage.getItem("puesto"));
    const bandera = localStorage.getItem("bandera");
    const url = puesto && puesto?.isShop
      ? "/json/articulos-shop.json"
      : bandera === "shell"
        ? "/json/articulos-playa-shell.json"
        : "/json/articulos-playa.json";
    const response = await fetch(url);
    const data = await response.json();
    return data.articulos;
  } catch (error) {
    console.error("Error al cargar artículos:", error);
    return [];
  }
};

const getArticulosHabilitados = async searchString => {
  const articulosSeleccionados = await getArticulosByBandera();

  const filtro = searchString?.toLowerCase()?.trim();

  const articulosFiltrados = filtro
    ? articulosSeleccionados.filter(articulo => articulo.descripcion?.toLowerCase()?.includes(filtro) || articulo.codigoBarra?.toString()?.includes(filtro))
    : articulosSeleccionados;

  return {
    data: {
      articulos: articulosFiltrados,
    },
    status: 200,
    statusText: "OK",
  };
};

const articulos = {
  getArticulosHabilitados,
};

export default articulos;
